export default "__VITE_ASSET__CwAvvaZk__"